
import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import { getModule } from 'vuex-module-decorators';
import { ThemeConfModule } from '@/store/modules/theme';
import { Fragment } from 'vue-fragment';
import { ThemeConf, TemplatedSlide, DisplayLink } from '@/types/ThemeConf';
import { localize } from '@/filters/localize';
import { AppModule } from '@/store/modules/app';

const AppState = getModule(AppModule, store);
var sanitizeUrlHelper = require('@braintree/sanitize-url').sanitizeUrl;
const Theme = getModule(ThemeConfModule, store);


@Component({
  components: {
    Fragment
  }
})
export default class ThemedSlide extends Vue {
  slideContent: TemplatedSlide | undefined;
  themeConfig: ThemeConf | null = null;

  get isDebug() {
    return AppState.isDebug === true;
  }

  created() {
    this.themeConfig = Theme.getTheme;
    this.slideContent = this.themeConfig?.slides?.insertSlide;
  }

  getDefaultLinkDescription(displayText: string){
    return displayText ?? localize('Review');
  }

  get title() :string{
    if (this.isDebug)
      return 'Example title';
    return this.slideContent?.title ?? localize('Learning material');
  }

  get content() :string{
    if (this.isDebug)
      return 'This mocked content is only here during development and will be changed by actual admin-created content when added via course editor';
    return this.slideContent?.content ?? '';
  }

  get links() :Array<DisplayLink>{
    if (this.isDebug)
      return [{
        url: 'https://www.knowbe4.com/about-us/',
        displayText: 'Review'
      }];
    return this.slideContent?.links?.map(link => ({
      ...link,
      displayText: this.getDefaultLinkDescription(link.displayText)
    })) ?? [];
  }

  sanitizeUrl(url: string) {
    return sanitizeUrlHelper(url);
  }
}
